module.exports = __webpack_public_path__ + "static/img/play2.57800e94.png";